export default function () {
  const widgetName = "brochureMainRight";
  const widgetOpts = brochureMainRightOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: "BUY NOW",
    },
    cardWidgetLoaded: function () {
      $(`#${widgetName}`).find(".card-widget-title").remove();
      const buyBtn = $(`#${widgetName}`).find(".moreButton");
      // clone buyBtn into .white-section
      buyBtn.addClass("brochure-buy-btn").clone().appendTo(".white-section");
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: "BUY TICKETS",
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
